<template>
    <div class="main">
        <c-panel title="REQUERIMENTOS" titleIcon="fas fa-clipboard-list">
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="6">
                    <el-input v-model="filtro.busca" placeholder="Protocolo, nome, descrição" @keyup.enter.native="load" clearable></el-input>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-select v-model="filtro.tipo_requerimento_id" placeholder="Tipo" filterable clearable @change="load" style="width:100%;">
                        <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6">
                    <el-select v-model="filtro.status_workflow" placeholder="Status" clearable @change="load" style="width:100%;">
                        <el-option v-for="s in STATUS" :key="s.v" :label="s.l" :value="s.v"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <el-button @click="load" icon="el-icon-search">FILTRAR</el-button>
                    <router-link to="/admin/requerimento/cadastro"><el-button type="primary" icon="el-icon-plus">NOVO</el-button></router-link>
                </el-col>
            </el-row>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:90px;">Protocolo</th>
                        <th style="width:140px;">Tipo</th>
                        <th>Solicitante</th>
                        <th style="width:110px;">Aberto em</th>
                        <th style="width:140px;">Status</th>
                        <th style="width:240px;" class="u-text-center">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="r in items" :key="r.id">
                        <td>{{ r.numero_protocolo }}</td>
                        <td>{{ r.tipo_requerimento ? r.tipo_requerimento.nome : '—' }}</td>
                        <td>
                            <span v-if="r.aluno">{{ r.aluno.nome }} <small style="color:#909399;">(aluno)</small></span>
                            <span v-else-if="r.servidor">{{ r.servidor.nome }} <small style="color:#909399;">(servidor)</small></span>
                            <span v-else>{{ r.solicitante_nome || '—' }}</span>
                        </td>
                        <td>{{ r.data_abertura | formatarData }}</td>
                        <td><el-tag :type="tagStatus(r.status_workflow)" size="mini">{{ rotuloStatus(r.status_workflow) }}</el-tag></td>
                        <td class="u-text-center">
                            <router-link :to="'/admin/requerimento/edit/' + r.id">
                                <el-button size="mini" type="info" icon="el-icon-edit" plain></el-button>
                            </router-link>
                            <el-button v-if="r.status_workflow !== 5" size="mini" type="warning" plain @click="abrirMudarStatus(r)">STATUS</el-button>
                            <el-button size="mini" type="primary" plain icon="el-icon-printer" @click="imprimir(r)"></el-button>
                            <el-button v-if="r.status_workflow === 1" size="mini" type="danger" plain icon="el-icon-delete" @click="excluir(r.id)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length">
                        <td colspan="6" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum requerimento.</td>
                    </tr>
                </tbody>
            </table>

            <el-dialog title="Mudar status do requerimento" :visible.sync="modalStatusVisivel" width="540px">
                <p v-if="reqAtivo"><strong>Protocolo:</strong> {{ reqAtivo.numero_protocolo }} — atual: <el-tag :type="tagStatus(reqAtivo.status_workflow)" size="mini">{{ rotuloStatus(reqAtivo.status_workflow) }}</el-tag></p>
                <el-form label-position="top">
                    <el-form-item label="Novo status">
                        <el-select v-model="formStatus.novo" style="width:100%;">
                            <el-option v-for="s in STATUS" :key="s.v" :label="s.l" :value="s.v" :disabled="s.v === (reqAtivo ? reqAtivo.status_workflow : 0)"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Resposta / parecer (será notificado ao solicitante quando DEFERIDO/INDEFERIDO)">
                        <el-input type="textarea" v-model="formStatus.resposta" :rows="4"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalStatusVisivel = false">CANCELAR</el-button>
                    <el-button type="primary" @click="confirmarMudarStatus">APLICAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
import moment from 'moment'
const STATUS = [
    { v: 1, l: 'Aberto' }, { v: 2, l: 'Em análise' },
    { v: 3, l: 'Deferido' }, { v: 4, l: 'Indeferido' }, { v: 5, l: 'Arquivado' }
]
export default {
    filters: { formatarData (v) { return v ? moment(v).format('DD/MM/YYYY') : '' } },
    data () {
        return {
            STATUS, items: [], tipos: [],
            filtro: { busca: '', tipo_requerimento_id: null, status_workflow: null },
            modalStatusVisivel: false, reqAtivo: null,
            formStatus: { novo: null, resposta: '' }
        }
    },
    mounted () { this.load(); this.carregarTipos() },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        rotuloStatus (s) { const x = STATUS.find(o => o.v === Number(s)); return x ? x.l : '?' },
        tagStatus (s) { return { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger', 5: '' }[s] || '' },

        load () {
            this.$axios.post(`${this.baseUrl()}/api/requerimento/getAllPaginate`,
                { instituicao_id: this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : null, ...this.filtro },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.items = (r.data && r.data.data) ? r.data.data : (r.data || []) })
              .catch(e => this.$store.commit('throwException', e))
        },
        carregarTipos () {
            this.$axios.post(`${this.baseUrl()}/api/tipo-requerimento/getAllPaginate`, { situacao: true }, this.$store.getters.getHeaderAuth)
                .then(r => { this.tipos = (r.data && r.data.data) ? r.data.data : (r.data || []) })
        },
        excluir (id) {
            this.$confirm('Excluir requerimento?', 'Confirmar', { type: 'warning' }).then(() => {
                this.$axios.delete(`${this.baseUrl()}/api/requerimento/delete/${id}`, this.$store.getters.getHeaderAuth).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    this.load()
                })
            }).catch(() => {})
        },
        imprimir (r) {
            this.$axios.get(`${this.baseUrl()}/api/requerimento/imprimir/${r.id}`, {
                ...this.$store.getters.getHeaderAuth, responseType: 'blob'
            }).then(res => {
                const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
                window.open(url, '_blank')
            })
        },
        abrirMudarStatus (r) {
            this.reqAtivo = r
            this.formStatus = { novo: null, resposta: r.resposta || '' }
            this.modalStatusVisivel = true
        },
        confirmarMudarStatus () {
            if (!this.formStatus.novo) {
                window.eventBus.$emit('alert', { msg: 'Selecione o novo status.', type: 'warning' }); return
            }
            this.$axios.post(`${this.baseUrl()}/api/requerimento/mudarStatus/${this.reqAtivo.id}`,
                { status_workflow: this.formStatus.novo, resposta: this.formStatus.resposta },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Status atualizado.', type: 'success' })
                this.modalStatusVisivel = false
                this.load()
            })
        }
    }
}
</script>
